var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',[_c('img',{staticClass:"logo",attrs:{"alt":"Vue logo","src":require("./assets/logo.png")}})])])
}]

export { render, staticRenderFns }